export const ADDTEAM_INITIALIZE = 'PAGE_ADDTEAM_INITIALIZE';
export const ADDTEAM_CHANGE_EMAIL = 'PAGE_ADDTEAM_CHANGE_EMAIL';
export const ADDTEAM_CLEAR_SUCCESS = 'PAGE_ADDTEAM_CLEAR_SUCCESS';
export const ADDTEAM_FORM_ERROR = 'PAGE_ADDTEAM_FORM_ERROR';
export const ADDTEAM_RENDER_TEXTFIELD = 'PAGE_ADDTEAM_RENDER_TEXTFIELD';
export const ADDTEAM_ADD_PHONE = 'PAGE_ADDTEAM_ADD_PHONE';
export const ADDTEAM_CHANGE_PHONE = 'PAGE_ADDTEAM_CHANGE_PHONE';
export const ADDTEAM_CHANGE_PREFS = 'PAGE_ADDTEAM_CHANGE_PREF';
export const ADDTEAM_CHANGE_MESSAGE = 'PAGE_ADDTEAM_CHANGE_MESSAGE';
export const ADDTEAM_CHANGE_PERMISSIONS = 'PAGE_ADDTEAM_CHANGE_PERMISSIONS';

export function initialize() {
  return {
    type: ADDTEAM_INITIALIZE
  };
}

export function changeEmail(email) {
  return {
    type: ADDTEAM_CHANGE_EMAIL,
    email
  };
}

export function changePhone(phone) {
  return {
    type: ADDTEAM_CHANGE_PHONE,
    phone
  };
}

export function changeMessage(message) {
  return {
    type: ADDTEAM_CHANGE_MESSAGE,
    message
  };
}

export function changePrefs(prefs) {
  return {
    type: ADDTEAM_CHANGE_PREFS,
    prefs
  };
}

export function changePermissions(permissions) {
  return {
    type: ADDTEAM_CHANGE_PERMISSIONS,
    permissions
  };
}

export function clearSuccess() {
  return {
    type: ADDTEAM_CLEAR_SUCCESS
  };
}

export function formError(error) {
  return {
    type: ADDTEAM_FORM_ERROR,
    error
  };
}

export function renderTextField() {
  return {
    type: ADDTEAM_RENDER_TEXTFIELD
  };
}

export function addPhone() {
  return {
    type: ADDTEAM_ADD_PHONE
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/admin/AddTeamMember.js